import { createContext } from 'react';
const state = {
    coApp: {
        addressLine1: '',
        addressLine2: '',
        telePhoneHome: '',
        city: '',
        zip: '',
        state: '',
    },
};

const JointAppContext = createContext(state);

export { state, JointAppContext };
